/**
 * Single source of truth for the Market Expansion TanStack Query key prefixes.
 */
export const MARKET_EXPANSION_QUERY_KEYS = {
  marketplacePayerPlanCounts: "market-expansion__marketplace-payer-plan-counts",
  medicaidPayerPlanCounts: "market-expansion__medicaid-payer-plan-counts",
  medicaidPrograms: "market-expansion__medicaid-programs",
} as const;
